import { connect } from 'react-redux';
import TitleBar from './TitleBar';
import {
  openExportDialog,
  closeExportDialog,
} from '../../actions/exportDialog';
import { getExportDialogOpen } from '../../selectors/exportDialog';

export default connect(
  state => ({
    isExportDialogOpen: getExportDialogOpen(state),
  }),
  {
    openExportDialog,
    closeExportDialog,
  },
)(TitleBar);



// WEBPACK FOOTER //
// ./src/components/TitleBar/TitleBarContainer.jsx